import { render, staticRenderFns } from "./openFutures.vue?vue&type=template&id=4b55982d&scoped=true&"
import script from "./openFutures.vue?vue&type=script&lang=js&"
export * from "./openFutures.vue?vue&type=script&lang=js&"
import style0 from "./openFutures.vue?vue&type=style&index=0&id=4b55982d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55982d",
  null
  
)

export default component.exports